import ClassModel, { isClass } from "src/models/ClassModel";
import MembershipOfferingModel, {
  isMembershipOffering,
} from "src/models/MembershipOfferingModel";
import OfferingModel, { isOffering } from "src/models/OfferingModel";
import { useStore } from "src/stores/Store";
import colors from "src/utils/colors";
import { MembershipOfferingTypes } from "src/utils/constants";
import { IntegrationType } from "types/code-generator";

interface Props {
  offering: ClassModel | MembershipOfferingModel | OfferingModel;
  isPreview?: boolean;
}

export default function OfferingIcon(props: Props) {
  const store = useStore();

  let icon;
  let label;

  if (isClass(props.offering)) {
    if (props.offering.integration === IntegrationType.USASwimming) {
      icon = <img src="/img/usaswimming.jpg" className="h-8 w-8" />;
    } else {
      icon = <i aria-hidden className="far fa-calendar-day" />;
    }

    label = props.offering.type;
  } else if (isMembershipOffering(props.offering)) {
    if (props.offering.integration === IntegrationType.USASwimming) {
      icon = (
        <img
          src="/img/usaswimming.jpg"
          alt="USA Swimming"
          className="h-8 w-8"
        />
      );
      label = props.offering.type;
    } else if (
      props.offering.type === MembershipOfferingTypes["Limited Pass"]
    ) {
      icon = <i aria-hidden className="far fa-ticket" />;
      label = props.offering.passType;
    } else {
      icon = <i aria-hidden className="far fa-certificate" />;
      label = props.offering.type;
    }
  } else if (isOffering(props.offering)) {
    icon = <i aria-hidden className="far fa-clipboard-list-check" />;
    label = `Custom ${props.offering.type}`;
  }

  return (
    <div
      className="flex items-center"
      style={{
        color:
          store.isAdminArea && !props.isPreview
            ? colors.dark
            : store.theme.orgOrgColor,
      }}
    >
      <div
        className="mr-2"
        style={{
          color: props.isPreview
            ? store.theme.orgOrgColor
            : store.theme.orgColor,
        }}
      >
        {icon}
      </div>
      <div className="text-xs font-bold uppercase">{label}</div>
    </div>
  );
}
